import { h, Component } from 'preact';
import NMAgentForm from 'components/nm_agent_form.component';
import NMEnsemble from 'components/nm_ensemble.component';
import RepPhoneNumber from 'components/nm_rep_phone_number.component';
import { jsxWith, jsxIf } from 'utils/jsx.util';
import { PHONE_MEDIA_QUERY } from 'constants/media_query.constants';
import resolveFrPhoto from 'utils/resolveFrPhoto.util';

/*
NMRepCard

Properties:
	rep - An instanceof of a FinancialRep to display information for
	target (optional) - The url to go to when 'Get Quote' is clicked
*/
export default class NMRepCard extends Component {
  constructor(props) {
    super(props);
    this.state = { isExpanded: false };
  }

  expand() {
    this.setState({ isExpanded: true });
  }

  collapse() {
    this.setState({ isExpanded: false });
  }

  toggle() {
    this.setState({ isExpanded: !this.state.isExpanded });
  }


  render() {
    return jsxWith(this.props.rep, rep => (
      <div className={`
        nm-rep-card
        ${this.state.isExpanded ? 'is-expanded' : ''}
      `}>
        <div className='nm-rep-card--info'>
          <div className='nm-rep-card--primary-info'>
            <picture className='nm-rep-card--photo'>
              <img src={resolveFrPhoto(rep)} alt={rep.fullName} title={rep.fullName} />
            </picture>
            <div className='nm-rep-card--title'>
              <h2 className='nm-rep-card--name'>{rep.fullName}</h2>
              <h3 className='nm-rep-card--role'>{rep.standardizedTitle}</h3>
              <NMEnsemble agentnumber={rep.id}></NMEnsemble>
            </div>
          </div>
          <div className='nm-rep-card--additional-info'>
            <ul className='nm-rep-card--designations'>
              {rep.designations.map((designation, index) => (
                <li>
                  <span>{designation}</span>
                </li>
              ))}
            </ul>
            <a href='http://brokercheck.finra.org/' target='_blank' rel='nofollow noopener' title='FINRA BrokerCheck'>
              FINRA BrokerCheck
            </a>
          </div>
        </div>
        <div className='nm-rep-card--contact'>
          <address className="nm-rep-card--address">{rep.formattedAddress}</address>
          {rep.selectedPhone1 ? <RepPhoneNumber phoneNumber={rep.selectedPhone1.Number}/> : false}
          {rep.selectedPhone2 ? <RepPhoneNumber phoneNumber={rep.selectedPhone2.Number}/> : false}
          {rep.selectedPhone3 ? <RepPhoneNumber phoneNumber={rep.selectedPhone3.Number}/> : false}
          <ul className='nm-rep-card--contact-links'>
            {jsxIf(rep.slug, () => (
              <li>
                <a href={`/financial/advisor/${rep.slug}/`}>view my profile page</a>
              </li>
            ))}
          </ul>
          <button className='nmx-button nmx-button--secondary' onClick={this.toggle.bind(this)}>
            Contact
            <img src='<%=templateBasePath%>/images/chevron-right.svg' />
          </button>
        </div>
        {jsxIf(this.state.isExpanded, () => (
          <div className='nm-rep-card--dropdown'>
            <div className='nm-rep-card--dropdown-info'>
              {jsxIf(rep.briefBio, () => (
                <h3 className='is-uppercase'>About My Practice</h3>
              ))}
              {jsxIf(rep.briefBio, () => (
                <p>
                  {rep.briefBio}
                </p>
              ))}
              <h3 className='is-uppercase'>Location</h3>
              <a href={`http://maps.google.com/maps?q=loc:${rep.latitude},${rep.longitude}`} target='_blank' rel='nofollow noopener' title='View in Google Maps'>
                <picture>
                  <source srcset={`https://maps.googleapis.com/maps/api/staticmap?center=${rep.latitude},${rep.longitude}&size=250x414&markers=${rep.latitude},${rep.longitude}&maptype=roadmap&zoom=13&key=<%=googlePlacesApiKey%>`} media={PHONE_MEDIA_QUERY} />
                  <img src={`https://maps.googleapis.com/maps/api/staticmap?center=${rep.latitude},${rep.longitude}&size=534x282&markers=${rep.latitude},${rep.longitude}&maptype=roadmap&zoom=13&key=<%=googlePlacesApiKey%>`} alt='Google Map'/>
                </picture>
              </a>
            </div>
            <div className='nm-rep-card--dropdown-service'>
              <NMAgentForm agentnumber={rep.id} formlocation='dir' campaign={this.props.campaign} floodlightsendto={this.props.floodlightsendto}/>
            </div>
          </div>
        ))}
      </div>
    ));
  }
}
